import { Grid, withStyles } from '@material-ui/core';
import classNames from 'classnames';
import { Field, Formik } from 'formik';
import PropTypes from 'prop-types';
import React, { PureComponent } from 'react';
import OtpInput from 'react-otp-input';
import CustomDialog from '../../shared/Modals/CustomDialog';
import * as Yup from 'yup';
import PrimaryButton from '../../shared/Buttons/PrimaryButton';
import { TransunionChannels } from '../../../constants/enums';

const validationSchema = Yup.object().shape({
  otp: Yup.string().test(
    'len',
    'Debe tener exactamente 4 caracteres',
    val => val && val.toString().length === 4
  )
});

class OTPTransunionValidationProcess extends PureComponent {
  state = {
    timerMinutes: '0',
    timerSeconds: '0',
    interval: null,
    isTimeOver: false
  };

  _handleChange = (otp, handleChange) => {
    const evt = { target: { value: otp, name: 'otp' } };
    handleChange(evt);
  };

  getRemainingTime = () => {
    const remainingTime = this.props.timeRemaining - Date.now();
    const minutes = (remainingTime / 1000 / 60) % 60;
    const seconds = (remainingTime / 1000) % 60;

    this.setState(prev => ({
      ...prev,
      timerMinutes: minutes >= 1 ? `0${Math.floor(minutes)}` : '00',
      timerSeconds:
        seconds >= 0 ? `${seconds < 10 ? '0' : ''}${Math.floor(seconds)}` : '00'
    }));
  };

  _handleValidateOtp = otp => {
    this.props.verifyOtpTransunion(
      {
        applicationId: this.props.applicationId.toString(),
        otpCode: otp,
        currentClient: this.props.currentClient,
        hasCosigner: this.props.hasCosigner,
        contractId: this.props.contractId,
        identification: this.props.identification,
      },
      this.props.route,
      this.props.process
    );
  };

  componentDidMount() {
    this.setState(prev => ({
      ...prev,
      interval: setInterval(() => this.getRemainingTime(), 1000)
    }));
  }

  componentDidUpdate(prevProps) {
    if (this.state.timerMinutes === '00' && this.state.timerSeconds === '00') {
      this.setState({ isTimeOver: true });
      clearInterval(this.state.interval);
    }

    if (this.props.timeRemaining !== prevProps.timeRemaining) {
      this.setState({
        isTimeOver: false,
        timerMinutes: '02',
        interval: setInterval(() => this.getRemainingTime(), 1000)
      });
    }
  }

  componentWillUnmount() {
    if (this.state.interval) {
      clearInterval(this.state.interval);
    }
  }

  render() {
    const {
      open,
      selectedMethod,
      mobile,
      email,
      classes,
      applicationId,
      resendOtpTransunion,
      loading,
    } = this.props;

    const { isTimeOver } = this.state;

    let emailText = '';
    let mobileText = '';

    switch (selectedMethod) {
      case TransunionChannels.SMS:
        mobileText = `celular (${mobile})`;
        break;
      case TransunionChannels.Email:
        emailText = `correo (${email})`;
        break;
    }

    return (
      <CustomDialog
        open={open}
        title={`Validación OTP`}
        contentText={`Ingrese el código enviado a su ${mobileText || emailText}.`}
        disableBackdropClick={true}
      >
        <Formik
          initialValues={{ otp: '' }}
          onSubmit={async values => this._handleValidateOtp(values.otp)}
          validationSchema={validationSchema}
          validateOnChange={false}
          validateOnBlur={false}
          render={({ values, handleChange, handleSubmit }) => {
            return (
              <div className={classes.otpbody}>
                <b>{`Tiempo restante ${this.state.timerMinutes}:${this.state.timerSeconds}. ${isTimeOver ? 'El código ha expirado' : ''}`}</b>
                <Field
                  name="otp"
                  render={({ field, form }) => {
                    return (
                      <OtpInput
                        numInputs={4}
                        isInputNum={true}
                        onChange={otp => this._handleChange(otp, handleChange)}
                        value={values.otp}
                        field={field}
                        form={form}
                        shouldAutoFocus={true}
                        inputStyle={classNames(classes.otpInputStyle)}
                      />
                    );
                  }}
                />
                <PrimaryButton
                  onClick={handleSubmit}
                  className={classes.button}
                  disabled={values.otp.length !== 4 && !loading || isTimeOver}
                  loading={loading}
                >
                  Enviar
                </PrimaryButton>
                {!loading && mobileText !== '' && <>
                  <Grid container justify="center" alignItems="center" style={{ marginTop: '20px' }}>
                    <Grid item>
                      <span style={{ color: '#707070' }}>
                        Si no recibió el código, puede reenviarlo o pasar a preguntas de seguridad.
                      </span>
                    </Grid>
                  </Grid>
                  <Grid container justify="space-around" alignItems="center" style={{ marginTop: '20px' }}>
                    <Grid item>
                      <PrimaryButton
                        variant="contained"
                        onClick={() => resendOtpTransunion({ applicationId: applicationId.toString(), mobile: mobile.toString(), email })}
                        className={classes.questionButton}
                        disabled={loading || !isTimeOver}
                      >
                        Reenviar OTP
                      </PrimaryButton>
                    </Grid>
                  </Grid>
                </>}
              </div>
            );
          }}
        />
      </CustomDialog>
    );
  }
}

OTPTransunionValidationProcess.propTypes = {
  open: PropTypes.bool.isRequired,
  selectedMethod: PropTypes.string.isRequired,
  mobile: PropTypes.string.isRequired,
};

const styles = theme => ({
  otpInputStyle: {
    width: '3rem !important',
    margin: '20px 1rem',
    borderBottom: '2px solid #707070',
    color: '#2C3C47',
    fontFamily: 'Roboto',
    fontSize: '50px'
  },
  questionButton: {
    alignSelf: 'flex-end',
    backgroundColor: '#fca903',
    color: 'white',
    paddingLeft: 4 * theme.spacing.unit,
    paddingRight: 4 * theme.spacing.unit
  },
  resendButton: {
    alignSelf: 'flex-start',
    backgroundColor: '#fca903',
    color: 'white',
    paddingLeft: 4 * theme.spacing.unit,
    paddingRight: 4 * theme.spacing.unit
  },
  otpbody: {
    display: 'flex',
    justifyContent: 'center',
    flexDirection: 'column',
    alignItems: 'center',
    marginTop: `${theme.spacing.unit * 7.375}px !important`,
    color: '#707070'
  }
});

export default withStyles(styles)(OTPTransunionValidationProcess);
